import { Spin } from 'antd'

import styled from '@emotion/styled'

export const StyledSpin = styled(Spin)`
  .ant-spin-dot-item {
    background-color: white;
  }
`
